export const RegionType = {
    NONE: 'none',
    SLIDELIST: 'slidelist',
    EDITOR: 'editor',
    NOTE: 'note',
    PLAYER: 'player',
};

export type RegionType = typeof RegionType[keyof typeof RegionType];
